import { Modal } from 'antd'
import React from 'react'

const DeleteLineItemModal = ({
  deleteRowHandler,
  selectedEmployeeData,
  setShowRemoveEmployeeModal,
  showRemoveEmployeeModal,
  setSelectedEmployeeData,
}) => {
  return (
    <Modal
      title="Do you want to remove this employee?"
      open={showRemoveEmployeeModal}
      onOk={() => deleteRowHandler(selectedEmployeeData)}
      onCancel={() => {
        setShowRemoveEmployeeModal(false)
        setSelectedEmployeeData()
      }}
      okText="Yes"
      cancelText="No"
      className="custom-modal delete-employee-modal"
    >
      <div className="employee-detail">
        <p>
          <span>Name:</span>
          {selectedEmployeeData?.isService
            ? selectedEmployeeData?.name
            : selectedEmployeeData?.employeeName}
        </p>
        {selectedEmployeeData?.isService ? (
          <p>
            <span>Amount:</span> {selectedEmployeeData?.rate}
          </p>
        ) : (
          <>
            <p>
              <span>Rate:</span> {selectedEmployeeData?.rate}
            </p>
            <p>
              <span>Billed Hours:</span>
              {selectedEmployeeData?.calculatedBillingHours}
            </p>
          </>
        )}
      </div>
    </Modal>
  )
}
export default DeleteLineItemModal
